import { constants } from '../constants/global.constants';
import { isTradeDialogOpen } from '../selectors/dialog.selector';
import { Reducer } from 'redux';
import { 
    PHASE_PLAN_DIALOG_OPEN,
    PRINT_BOARD_DIALOG_OPEN,
    PRINT_BOARD_DIALOG_CLOSE, 
    PHASE_PLAN_DIALOG_CLOSED, 
    PHASE_PLAN_START_DIALOG_CLOSE, DialogAction, PHASE_PLAN_START_DIALOG_OPEN, COPY_TAGS,HELP_INFO_DIALOG_CLOSE, HELP_INFO_DIALOG_OPEN, CONSTRAINT_DIALOG_OPEN, CONSTRAINT_DIALOG_CLOSE, CONSTRAINT_LOG_DIALOG_OPEN, CONSTRAINT_LOG_DIALOG_CLOSE, COMMIT_DIALOG_CLOSE, COMMIT_DIALOG_OPEN, VARIANCE_LOG_DIALOG_OPEN, VARIANCE_LOG_DIALOG_CLOSE, END_COMMITMENT_DIALOG_CLOSE, END_COMMITMENT_DIALOG_OPEN, CLEAR_COPY_TAGS, ROW_COUNT_DIALOG_OPEN, ROW_COUNT_DIALOG_CLOSED, MRP_DIALOG_OPEN, MRP_DIALOG_CLOSED, HUDDLE_SETTING_DIALOG_OPEN, HUDDLE_SETTING_DIALOG_CLOSE } from '../actions/dialog.actions';
import { ColumnType } from '../components/PhasePlan/Column';
import { TagType, SelectedTag } from '../models/ TagType';
import { LOCATION_CHANGE } from 'connected-react-router';
import { EDIT_AREA_DIALOG_CLOSED,  EDIT_AREA_DIALOG_OPEN, EDIT_AREA_DIALOG_ZONE_CLOSED, EDIT_AREA_DIALOG_ZONE_OPEN } from '../actions/area.actions';

export interface DialogState {
    readonly openResource: boolean,
    readonly addResourceLoading: boolean,
    readonly openDeleteResource: boolean,
    readonly resourceUid: string | null,
    readonly deleteProjectId: string | null,
    readonly isAddIssueDialogOpen: boolean,
    readonly openTimeline: boolean,
    readonly issueId: string | null,
    readonly openIssueDeleteDialog: boolean,
    readonly openProjectUserDialogOpen: boolean,
    readonly isTagDialogOpen: boolean,
    readonly isTradeDialogOpen: boolean,
    readonly isPhasePlanDialogOpen: boolean,
    readonly tradeToEditId: string | null,
    readonly tagToEditId: string | null,
    readonly deleteTagIds: Record<string, SelectedTag> | null,
    readonly batchTagIds: Record<string, SelectedTag> | null,
    readonly dupTagIds: Record<string, SelectedTag> | null,
    readonly ripTagId: string | null,
    readonly ripTagType: TagType | null,
    readonly dupTagType: ColumnType | null,
    readonly deleteTagType: ColumnType | null,
    readonly startLookaheadPhaseKey: string | null,
    readonly copiedPhaseTags:  Record<string, SelectedTag>,
    readonly copiedLookaheadTags:  Record<string, SelectedTag>,
    readonly isHelpInfoDialogOpen: boolean,
    readonly isConstraintDialogOpen: boolean,
    readonly isConstraintLogDialogOpen: boolean,
    readonly constraintId: string | null,
    readonly isCommitDialogOpen: boolean,
    readonly isVarianceLogDialogOpen: boolean,
    readonly isEndCommitmentDialogOpen: boolean,
    readonly isMilestone: boolean | null,
    readonly rowCountDialogInfo: number | null,
    readonly isMRPDialogOpen: boolean,
    readonly isPrintBoardOpen: boolean,
    readonly isHuddleSettingDialogOpen: boolean,
    readonly isEditAreaDialogOpen: boolean,
    readonly isEditAreaZoneDialogOpen: boolean,
    readonly areaKey: string | null
}
const initState:DialogState = {
    openResource: false,
    addResourceLoading: false,
    openDeleteResource: false,
    resourceUid: null,
    deleteProjectId: null,
    isAddIssueDialogOpen: false,
    openTimeline: false,
    issueId: null,
    openIssueDeleteDialog: false,
    openProjectUserDialogOpen: false,
    isTagDialogOpen: false,
    isTradeDialogOpen: false,
    isPhasePlanDialogOpen: false,
    isMRPDialogOpen: false,
    isHelpInfoDialogOpen: false,
    isConstraintDialogOpen: false,
    isCommitDialogOpen: false,
    isConstraintLogDialogOpen: false,
    tradeToEditId: null,
    tagToEditId: null,
    deleteTagIds: null,
    batchTagIds: null,
    dupTagIds: null,
    ripTagId: null,
    ripTagType: null,
    dupTagType: null,
    deleteTagType: null,
    startLookaheadPhaseKey: null,
    copiedPhaseTags: {},
    copiedLookaheadTags: {},
    constraintId: null,
    isVarianceLogDialogOpen: false,
    isEndCommitmentDialogOpen: false,
    isMilestone: null,
    rowCountDialogInfo: null,
    isPrintBoardOpen: false,
    isHuddleSettingDialogOpen: false,
    isEditAreaDialogOpen: false,
    areaKey: null,
    isEditAreaZoneDialogOpen: false
}
export const dialogReducer:Reducer<DialogState> = (
    state = initState, action: DialogAction | any) => {
    
    switch (action.type) {
        case PRINT_BOARD_DIALOG_OPEN: 
            return Object.assign({}, state, {
                isPrintBoardOpen: true
            })
        case PRINT_BOARD_DIALOG_CLOSE: 
            return Object.assign({}, state, {
                isPrintBoardOpen: false
            })
        case ROW_COUNT_DIALOG_OPEN: 
            return Object.assign({}, state, {
                rowCountDialogInfo: action.payload.row
            })
        case ROW_COUNT_DIALOG_CLOSED: 
            return Object.assign({}, state, {
                rowCountDialogInfo: null
            })
        case constants.OPEN_TAG_DIALOG: 
            return Object.assign({}, state, {
                tagToEditId: action.payload.tagId,
                isTagDialogOpen: true
            })
        case constants.CLOSE_TAG_DIALOG: 
            return Object.assign({}, state, {
                isTagDialogOpen: false,
                tagToEditId: null

            })
        case constants.OPEN_TRADE_DIALOG: 
            return Object.assign({}, state, {
                tradeToEditId: action.payload.tradeId,
                isTradeDialogOpen: true
            })
        case constants.CLOSE_TRADE_DIALOG: 
            return Object.assign({}, state, {
                isTradeDialogOpen: false,
                tradeToEditId: null
            })
        case constants.OPEN_PROJECT_USER_DIALOG: 
            return Object.assign({}, state, {
                openProjectUserDialogOpen: true
            })
        case constants.CLOSE_PROJECT_USER_DIALOG:
            return Object.assign({}, state, {
                openProjectUserDialogOpen: false
            })
        case constants.ISSUEDIALOG_OPEN:
            return Object.assign({}, state, {
                isAddIssueDialogOpen: true
            })
        case constants.ISSUEDIALOG_CLOSE:
            return Object.assign({}, state, {
                isAddIssueDialogOpen: false,
                issueId: null
            });
        case constants.OPEN_EDIT_ISSUE_DIALOG:
            return Object.assign({}, state, {
                isAddIssueDialogOpen: true,
                issueId: action.issueId
            });
        case constants.OPEN_DELETE_ISSUE_DIALOG:
            return Object.assign({}, state, {
                openIssueDeleteDialog: true,
                issueId: action.issueId,
                deleteProjectId: action.projectId
            });
        case constants.CLOSE_DELETE_ISSUE_DIALOG:
            return Object.assign({}, state, {
                openIssueDeleteDialog: false,
                issueId: null,
                deleteProjectId: null
            });
        case constants.OPEN_RESOURCE_DIALOG:
            return Object.assign({}, state, {
                openResource: true
            });
        case constants.CLOSE_RESOURCE_DIALOG:
            return Object.assign({}, state, {
                openResource: false,
                resourceUid: null
            });
        case constants.ADD_RESOURCE_LOADING:
            return Object.assign({}, state, {
                addResourceLoading: true
            });
        case constants.ADD_RESOURCE_STOP_LOADING:
            return Object.assign({}, state, {
                addResourceLoading: false
            });
        case constants.OPEN_DELETE_RESOURCE_DIALOG:
            return Object.assign({}, state, {
                openDeleteResource: true,
                resourceUid: action.resourceUid,
                deleteProjectId: action.projectId
            });
        case constants.CLOSE_DELETE_RESOURCE_DIALOG:
            return Object.assign({}, state, {
                openDeleteResource: false,
                resourceUid: null
            });
        case constants.OPEN_EDIT_RESOURCE_DIALOG:
            return Object.assign({}, state, {
                openResource: true,
                resourceUid: action.resourceUid
            })
        case constants.OPEN_TIMELINE_DIALOG:
            return Object.assign({}, state, {
                openTimeline: true
            })
        case constants.CLOSE_TIMELINE_DIALOG:
            return Object.assign({}, state, {
                openTimeline: false
            })
        case constants.OPEN_DELETE_TAG_DIALOG: 
            return Object.assign({}, state, {
                deleteTagIds: action.deleteTagIds,
                deleteTagType: action.deleteTagType,
                isMilestone: action.isMilestone,

            })
        case constants.CLOSE_DELETE_TAG_DIALOG: 
            return Object.assign({}, state, {
                deleteTagIds: null,
                deleteTagType: null,
                isMilestone: null,
            })
        case constants.CLOSE_BATCH_TAG_DIALOG: 
            return Object.assign({}, state, {
                batchTagIds: null,
            })
        case constants.OPEN_BATCH_TAG_DIALOG:
            return Object.assign({}, state, {
                batchTagIds: action.batchTagIds,
            })
        case constants.OPEN_DUPLICATE_TAG_DIALOG: 
            return Object.assign({}, state, {
                dupTagIds: action.dupTagIds,
                dupTagType: action.dupTagType
            })
        case constants.CLOSE_DUPLICATE_TAG_DIALOG: 
            return Object.assign({}, state, {
                dupTagIds: null
            })
        case constants.OPEN_RIP_TAG_DIALOG: 
            return Object.assign({}, state, {
                ripTagId: action.ripTagId,
                ripTagType: action.ripTagType
            })
        case constants.CLOSE_RIP_TAG_DIALOG: 
            return Object.assign({}, state, {
                ripTagId: null,
                ripTagType: null
            })
        case MRP_DIALOG_OPEN: 
            return Object.assign({}, state, {
                isMRPDialogOpen: true
            })
        case MRP_DIALOG_CLOSED: 
            return Object.assign({}, state, {
                isMRPDialogOpen: false
            })
        case PHASE_PLAN_DIALOG_OPEN:

            return Object.assign({}, state, {
                isPhasePlanDialogOpen: true
            })
        case PHASE_PLAN_DIALOG_CLOSED:

            return Object.assign({}, state, {
                isPhasePlanDialogOpen: false
            })
        case PHASE_PLAN_START_DIALOG_OPEN:
            return Object.assign({}, state, {
                startLookaheadPhaseKey: action.payload.startLookaheadPhaseKey
            })
        case PHASE_PLAN_START_DIALOG_CLOSE: 
            return Object.assign({}, state,{
                        startLookaheadPhaseKey: null   
                })
        case LOCATION_CHANGE:
            return {
                ...state,
                copiedPhaseTags: {},
                copiedLookaheadTags: {}
            }
        case COPY_TAGS:
            const type = action.payload.type
            if(type === ColumnType.PhasePlan) {
                return {
                    ...state,
                    copiedPhaseTags: action.payload.tags,
                    isMilestone: action.payload.isMilestone,
                }
            }

            if(type === ColumnType.Lookahead) {
                return {
                    ...state,
                    copiedLookaheadTags: action.payload.tags,
                    isMilestone: action.payload.isMilestone,
                }
            }

            return state
        case CLEAR_COPY_TAGS:
            return {
                ...state,
                copiedPhaseTags: {},
                copiedLookaheadTags: {},
                isMilestone: null,
            }
        case HELP_INFO_DIALOG_OPEN:
            return {
                ...state,
                isHelpInfoDialogOpen: true
            }
        case HELP_INFO_DIALOG_CLOSE:
            return {
                ...state,
                isHelpInfoDialogOpen: false
            }
        case CONSTRAINT_DIALOG_OPEN:
            return {
                ...state,
                isConstraintDialogOpen: true,
                constraintId: action.payload.constraintId
            }
        case CONSTRAINT_DIALOG_CLOSE:
            return {
                ...state,
                isConstraintDialogOpen: false,
                constraintId: null
            }
        case CONSTRAINT_LOG_DIALOG_OPEN:
            return {
                ...state,
                isConstraintLogDialogOpen: true
            }
        case CONSTRAINT_LOG_DIALOG_CLOSE:
            return {
                ...state,
                isConstraintLogDialogOpen: false
            }
        case VARIANCE_LOG_DIALOG_OPEN:
            return {
                ...state,
                isVarianceLogDialogOpen: true
            }
        case VARIANCE_LOG_DIALOG_CLOSE:
            return {
                ...state,
                isVarianceLogDialogOpen: false
            }
        case COMMIT_DIALOG_OPEN: 
            return {
                ...state,
                isCommitDialogOpen: true
            }
        case COMMIT_DIALOG_CLOSE: 

            return {
                ...state,
                isCommitDialogOpen: false
            }
        case END_COMMITMENT_DIALOG_OPEN:
            return {
                ...state,
                isEndCommitmentDialogOpen: true
            }
        case END_COMMITMENT_DIALOG_CLOSE:
            return {
                ...state,
                isEndCommitmentDialogOpen: false
            }
        case HUDDLE_SETTING_DIALOG_OPEN:
            return {
                ...state,
                isHuddleSettingDialogOpen: true
            }
        case HUDDLE_SETTING_DIALOG_CLOSE:
            return {
                ...state,
                isHuddleSettingDialogOpen: false
            }
        case EDIT_AREA_DIALOG_OPEN: 

            return Object.assign({}, state, {
              isEditAreaDialogOpen: true,
              areaKey: action.payload.areaKey
            });
        case EDIT_AREA_DIALOG_CLOSED: 
            return Object.assign({}, state, {
              isEditAreaDialogOpen: false,
              areaKey: null
            });
        case EDIT_AREA_DIALOG_ZONE_OPEN:
            return {
                ...state,
                isEditAreaZoneDialogOpen: true,
                areaKey: action.payload.areaKey
            }

        case EDIT_AREA_DIALOG_ZONE_CLOSED:
            return {
                ...state,
                isEditAreaZoneDialogOpen: false,
                areaKey: null
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/dialog.reducer.ts